import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export function slider() {


    const swiperCarousels = document.querySelectorAll(".swiper");

    if (swiperCarousels.length) {
        swiperCarousels.forEach(carouselContainer => {

            const carouselNextButton =
                carouselContainer.querySelector(".swiper-button-next") ||
                carouselContainer.parentElement.querySelector(
                    ".swiper-button-next"
                );

            const swiperInstance = new Swiper(carouselContainer, {
                modules: [Navigation],
                loop: true,
                navigation: {
                    nextEl: carouselNextButton,
                }
            });


        });
    }

}

